import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { HeadCell } from '../styled/TableHead';

var TableHeadCell = /*#__PURE__*/function (_React$Component) {
  _inherits(TableHeadCell, _React$Component);

  var _super = _createSuper(TableHeadCell);

  function TableHeadCell() {
    _classCallCheck(this, TableHeadCell);

    return _super.apply(this, arguments);
  }

  _createClass(TableHeadCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          inlineStyles = _this$props.inlineStyles,
          testId = _this$props.testId,
          rest = _objectWithoutProperties(_this$props, ["content", "inlineStyles", "testId"]);

      return /*#__PURE__*/React.createElement(HeadCell, _extends({
        style: inlineStyles,
        "data-testid": testId && "".concat(testId, "--head--cell")
      }, rest, {
        tabIndex: rest.isSortable ? 0 : undefined
      }), /*#__PURE__*/React.createElement("span", null, content));
    }
  }]);

  return TableHeadCell;
}(React.Component);

_defineProperty(TableHeadCell, "defaultProps", {
  innerRef: function innerRef() {},
  inlineStyles: {}
});

export default TableHeadCell;